import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular/main';
import { isEmpty } from 'lodash';
import { LinkParams } from './link-ag-renderer.component';

@Component({
    selector: 'test-link-ag-renderer',
    template: require('./test-link-ag-renderer.component.html'),
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TestLinkAgRendererComponent implements AgRendererComponent {
    public params: LinkParams;
    public isQuestion = false;

    public agInit(row: { value: LinkParams, node: any, data: any }): void {
        this.params = row.value;
        if (!row.node.group) {
            this.isQuestion = !!row.data.isQuestion;
        }
    }

    public refresh() {
        return false;
    }

    public get isLink() {
        return this.params && !isEmpty(this.params.routerLink) && !this.isQuestion;
    }

    public get tooltipText() {
        return this.params ? this.params.text : null;
    }

    public onQuestionMouseOver(event: MouseEvent) {
        // Don't show covance-tooltip together with Admin Question tooltip.
        event.stopPropagation();
    }
}